import React from 'react';
import { useT, i18n } from '../services/i18n';
import { renderMarkdown } from '../services/markdown';
import { useHomeContent } from '../services/homeContent';

const AboutSection = () => {
  const { t } = useT();
  const content = useHomeContent(i18n.get());
  const about = content?.about;
  return (
    <section className="py-6 sm:py-10 bg-gray-50" data-testid="home-about">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6" data-testid="home-about-title">
          {about?.title || t('home.aboutTitle')}
        </h2>
        {about ? (
          <div className="prose prose-gray max-w-none text-sm text-gray-600 space-y-4" data-testid="home-about-body" dangerouslySetInnerHTML={{ __html: renderMarkdown(about.paragraphs.join('\n\n')) }} />
        ) : (
          <div className="prose prose-gray max-w-none text-sm text-gray-600 space-y-4" data-testid="home-about-body">
            <p>{t('home.about1a')}<strong>{t('home.about1b')}</strong>{t('home.about1c')}</p>
            <p>{t('home.about2a')}<strong>{t('home.about2b')}</strong>{t('home.about2c')}</p>
            <p>{t('home.about3')}</p>
            <p>{t('home.about4a')}<strong>{t('home.about4b')}</strong>{t('home.about4c')}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default AboutSection;
